/**
 * @generated SignedSource<<c868d6a326acca2cad7e84c95fb71b5f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type templateDescriptionContentfulRelayFragment$data = {
  readonly aboutThisTemplate: {
    readonly json: any;
  } | null | undefined;
  readonly " $fragmentType": "templateDescriptionContentfulRelayFragment";
};
export type templateDescriptionContentfulRelayFragment$key = {
  readonly " $data"?: templateDescriptionContentfulRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"templateDescriptionContentfulRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "templateDescriptionContentfulRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductTemplateAboutThisTemplate",
      "kind": "LinkedField",
      "name": "aboutThisTemplate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "json",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductTemplate",
  "abstractKey": null
};

(node as any).hash = "feb20f99c8568003e487a1eac2d28713";

export default node;
